const designsData = [
  {
    id: 1,
    title: 'Github Mobile App Design',
    image: 'github-mobile-app.png',
    link: 'https://dribbble.com/shots/6849495-GitHub-Mobile-App-Dark-Mode'
  },
  {
    id: 2,
    title: 'King Hayman Vector Art',
    image: 'crown-hayman.png',
    link: 'https://www.instagram.com/p/B0QqutrpFUx/'
  },
  {
    id: 3,
    title: 'Travel/Map Mobile App (Night Mode)',
    image: 'google-map-app.png',
    link: 'https://dribbble.com/shots/6298029-Travel-Map-Mobile-App-Night-Mode'
  },
  {
    id: 4,
    title: 'Fire Slime Vector Art',
    image: 'fire-slime.png',
    link: 'https://www.instagram.com/p/B1OjtXbntft/'
  },
  {
    id: 5,
    title: 'Profile Card UI Design',
    image: 'profile-card.png',
    link: 'https://dribbble.com/shots/6635150-Profile-Card-UI'
  },
  {
    id: 6,
    title: 'Keyboard Vector Art',
    image: 'keyboard.png',
    link: 'https://www.instagram.com/p/B3KPnh2HptF/'
  }
];

export default designsData;
